import { render } from "./Loading.vue?vue&type=template&id=e5ff4e82"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=e5ff4e82&lang=css"

import exportComponent from "C:\\Users\\LMPELCHAT\\Documents\\vie-associative\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__